const animationCardsEffect = () => {
    const title = document.querySelector('.cards-container > h3');
    const cards = document.querySelectorAll('.cards-container .card');

    if (title) {
        gsap.from(title, {
            scrollTrigger: {
                trigger: title,
                once: true,
              },
            duration: 0.45,
            y: +40,
            autoAlpha: 0,
            ease: 'power2.out'
        })
    }

	if (cards.length) {
		gsap.set(cards, { autoAlpha: 0, y: +50 });

		ScrollTrigger.batch(cards, {
			onEnter: (batch) =>
				gsap.to(batch, {
					y: 0,
					autoAlpha: 1,
					duration: 0.6,
					ease: 'power2.out',
                    stagger: 0.25
				}),
			start: 'top bottom',
		});

		ScrollTrigger.addEventListener('refreshInit', () =>
			gsap.set(cards, { autoAlpha: 1, y: 0 })
		);
	}
};

export default animationCardsEffect;
